const base = "/school/academic-management";

export default [
    {
        title: "Academic sessions",
        description: "Create school sessions and set their dates.",
        path: `${base}/academic-sessions`,
        icon: "fa-calendar"
    },
    {
        title: "Terms",
        description: "Configure terms within each academic session.",
        path: `${base}/terms`,
        icon: "fa-clock"
    },
    {
        title: "Classes",
        description: "Create classes and set their assessment weighting.",
        path: `${base}/classes`,
        icon: "fa-graduation-cap"
    },
    {
        title: "Class options",
        description: "Create and organize the options available for each class.",
        path: `${base}/options`,
        icon: "fa-sitemap"
    },
    {
        title: "Class arms",
        description: "Create and manage arms within each class option.",
        path: `${base}/arms`,
        icon: "fa-list-ol"
    },
    {
        title: "Subjects",
        description: "Assign subjects and configure the school curriculum.",
        path: `${base}/subjects`,
        icon: "fa-book"
    },
    {
        title: "Psychomotor skills",
        description: "Configure psychomotor skills for student assessment.",
        path: `${base}/psycomotor-skills`,
        icon: "fa-child"
    },
    {
        title: "Conduct",
        description: "Set up conduct categories used in student evaluations.",
        path: `${base}/conduct`,
        icon: "fa-balance-scale"
    },
    {
        title: "Grade scale",
        description: "Define grading scales and result assessment bands.",
        path: `${base}/grade-scale`,
        icon: "fa-percent"
    },
    {
        title: "Mock exams",
        description: "Create and configure mock examinations for students.",
        path: `${base}/mock-exam`,
        icon: "fa-pencil"
    },
    {
        title: "Mock exam subjects",
        description: "Select and manage subjects included in mock exams.",
        path: `${base}/mock-exam-subjects`,
        icon: "fa-tasks"
    }
];
